import ExcludedAssets from '../excluded-assets';

const omitRecurring = (vendor, assetId, assets) => {
    const excludedAssets = ExcludedAssets.getAll(vendor);

    // parse response
    if (!assets) {
        return null
    }

    let nextAsset = null;

    for (let i = 0; i < assets.length; i += 1) {
        nextAsset = assets[i] || {};

        if (nextAsset.id !== assetId && excludedAssets.indexOf(nextAsset.id) === -1) {
            // exclude asset from recommended list
            ExcludedAssets.add(vendor, nextAsset.id);
            return nextAsset;
        }
    }

    return null;
};

const getFromArray = (array, randomIndex) => {
    return array[Math.floor(array.length * randomIndex)];
};

const getSource = (useMlEngine, experimentsList, experimentVariant) => {
    if(useMlEngine === false) {
        return 'related';
    }

    if(experimentsList.length > 1) {
        return `related-exprmnts/${getFromArray(experimentsList, experimentVariant)}`;
    }

    // no experiments set
    // use default against related ml without enhancements
    return getFromArray(['related-ml', 'related-exprmnts/default'], experimentVariant);
};


export default {
    omitRecurring,
    getSource
}